import Container from "./common/Container";
import Button from "./common/Button";
import More from "./common/More";
import Share from "./common/Share";
import Close from "./common/Close";

import Contact from "./event/Contact";
import RegisterExternal from "./event/RegisterExternal";
import RegisterInternal from "./event/RegisterInternal";
import MyTickets from "./event/MyTickets";

import Unlock from "./music/Unlock";
import GetSongExternal from "./music/GetSongExternal";
import Unlocked from "./music/Unlocked";
import PreviewInternal from "./music/PreviewInternal";
import PreviewExternal from "./music/PreviewExternal";
import Play from "./music/Play";
import JoinFanClub from "./music/JoinFanClub";

import MerchBuy from "./merch/Buy";
import MerchMyOrder from "./merch/MyOrder";

const Buttons = {
  common: {
    Container,
    Button,
    Share,
    More,
    Close,
  },
  event: {
    Contact,
    RegisterExternal,
    RegisterInternal,
    MyTickets,
  },
  music: {
    Unlock,
    Unlocked,
    GetSongExternal,
    PreviewInternal,
    PreviewExternal,
    Play,
    JoinFanClub,
  },
  merch: {
    Buy: MerchBuy,
    MyOrder: MerchMyOrder,
  },
};

export default Buttons;
